import { render, staticRenderFns } from "./ParentSaidItem.vue?vue&type=template&id=a5ad4cb4&scoped=true"
import script from "./ParentSaidItem.vue?vue&type=script&lang=js"
export * from "./ParentSaidItem.vue?vue&type=script&lang=js"
import style0 from "./ParentSaidItem.vue?vue&type=style&index=0&id=a5ad4cb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ad4cb4",
  null
  
)

export default component.exports